export const isArrayShallowEqual = (
  prev: readonly any[] | undefined,
  next: readonly any[]
): boolean =>
  !!prev &&
  prev.length === next.length &&
  prev.every((prevValue, i) => Object.is(prevValue, next[i]));
